import { useNavigate } from "react-router-dom";
import {
  dashboardClaimCorner,
  dashboardNetworkHospital,
  dashboardEmpQueries,
  dashboardEscalationMatrix,
  dashboardFAQ,
  dashboardUtilites,
  dashboardMembersCovered,
  dashboardPolicyDetails,
  dashboardBenefitsFeatures,
} from "../Assets";
import { MdArrowRight } from "react-icons/md";
import { toast, ToastContainer } from "react-toastify";
import { useContext } from "react";
import { AppContext } from "../ContextApi";

const DashboardFeatures = () => {
  const navigate = useNavigate();

  const { tabapiData } = useContext(AppContext);

  const isGmc = tabapiData.some((tab) => tab.policy_type_name == "GMC");

  const handleFeatureNavigate = (url) => {
    // console.log(isGmc , tabapiData[0]?.policy_visibility == 0 , tabapiData?.length == 1);
    if (
      tabapiData[0]?.policy_visibility == 0 &&
      tabapiData?.length == 1 &&
      isGmc
    ) {
      toast.error('page is unavailable');
    } else {
      navigate(url);
    }
  };

  return (
    <div className="dashboard-features-wrapper">
      <div className="row">
        <div className="col-lg-6">
          <div
            className="dashboard-feature-box"
            onClick={() => handleFeatureNavigate("/members-covered")}
          >
            <img src={dashboardMembersCovered}></img>
            <h5>Members Covered</h5>
            <button className="pinc-feature-btn">
              <MdArrowRight />
            </button>
          </div>
        </div>
        <div className="col-lg-6">
          <div
            className="dashboard-feature-box"
            onClick={() => handleFeatureNavigate("/policy-details")}
          >
            <img src={dashboardPolicyDetails}></img>
            <h5>Policy Details</h5>
            <button className="pinc-feature-btn">
              <MdArrowRight />
            </button>
          </div>
        </div>
        <div className="col-lg-6">
          <div
            className="dashboard-feature-box"
            onClick={() => handleFeatureNavigate("/mycoverage")}
          >
            <img src={dashboardBenefitsFeatures}></img>
            <h5>Benefit Features</h5>
            <button className="pinc-feature-btn">
              <MdArrowRight />
            </button>
          </div>
        </div>
        <div className="col-lg-6">
          <div
            className="dashboard-feature-box"
            onClick={() => handleFeatureNavigate("/claim-corner")}
          >
            <img src={dashboardClaimCorner}></img>
            <h5>Claims Corner</h5>
            <button className="pinc-feature-btn">
              <MdArrowRight />
            </button>
          </div>
        </div>
        <div className="col-lg-6">
          <div
            className="dashboard-feature-box"
            onClick={() => handleFeatureNavigate("/network-hospital")}
          >
            <img src={dashboardNetworkHospital}></img>
            <h5>Network Hospital</h5>
            <button className="pinc-feature-btn">
              <MdArrowRight />
            </button>
          </div>
        </div>
        <div className="col-lg-6">
          <div
            className="dashboard-feature-box"
            onClick={() => handleFeatureNavigate("/escalation-matrix")}
          >
            <img src={dashboardEscalationMatrix}></img>
            <h5>Escalation Matrix</h5>
            <button className="pinc-feature-btn">
              <MdArrowRight />
            </button>
          </div>
        </div>
        <div className="col-lg-6">
          <div
            className="dashboard-feature-box"
            onClick={() => handleFeatureNavigate("/download-form")}
          >
            <img src={dashboardUtilites}></img>
            <h5>Downloads</h5>
            <button className="pinc-feature-btn">
              <MdArrowRight />
            </button>
          </div>
        </div>

        <div className="col-lg-6">
          <div
            className="dashboard-feature-box"
            onClick={() => handleFeatureNavigate("/faq")}
          >
            <img src={dashboardFAQ}></img>
            <h5>FAQ's</h5>
            <button className="pinc-feature-btn">
              <MdArrowRight />
            </button>
          </div>
        </div>
      </div>
      {/* <ToastContainer/> */}
    </div>
  );
};

export default DashboardFeatures;
